import type { Namespace } from '../types';

// DE drafted — queued for native review. Fleet Inventory (R-097 P3): the cloud HQ
// read-only view of each site's auto-discovered device inventory (device_inventory_fleet).
export const fleetInventory = {
  title: { de: 'Flotten-Inventar', en: 'Fleet Inventory' },
  desc: {
    de: 'Automatisch erkannte Geräte je Standort — Controller, Kanäle, Modelle und Zustand. Von den Standorten hochsynchronisiert.',
    en: 'Auto-discovered devices per site — controllers, channels, models and health. Synced up from the sites.',
  },

  statDevices: { de: 'Controller', en: 'Controllers' },
  statSensors: { de: 'Sensoren', en: 'Sensors' },
  statActuators: { de: 'Aktoren', en: 'Actuators' },
  statFaults: { de: 'Störungen', en: 'Faults' },

  colDevice: { de: 'Controller', en: 'Controller' },
  colRoomType: { de: 'Raumtyp', en: 'Room type' },
  colFirmware: { de: 'Firmware', en: 'Firmware' },
  colSensors: { de: 'Sensoren', en: 'Sensors' },
  colActuators: { de: 'Aktoren', en: 'Actuators' },
  colHealth: { de: 'Zustand', en: 'Health' },
  colLastSeen: { de: 'Zuletzt gemeldet', en: 'Last reported' },

  colChannel: { de: 'Kanal', en: 'Channel' },
  colKind: { de: 'Typ', en: 'Kind' },
  colModel: { de: 'Modell', en: 'Model' },
  colPresent: { de: 'Vorhanden', en: 'Present' },
  colHealthy: { de: 'Zustand', en: 'Health' },

  sensor: { de: 'Sensor', en: 'Sensor' },
  actuator: { de: 'Aktor', en: 'Actuator' },
  healthy: { de: 'OK', en: 'Healthy' },
  faultsN: { de: '{n} Störung(en)', en: '{n} fault(s)' },
  present: { de: 'vorhanden', en: 'present' },
  absent: { de: 'fehlt', en: 'absent' },
  ok: { de: 'OK', en: 'OK' },
  fault: { de: 'Störung', en: 'Fault' },

  noSitesTitle: { de: 'Keine Standorte', en: 'No sites' },
  noSitesMsg: {
    de: 'Es sind noch keine Standorte für die Flottenansicht verfügbar.',
    en: 'No sites are available for the fleet view yet.',
  },
  loadError: { de: 'Inventar konnte nicht geladen werden', en: "Couldn't load inventory" },
  emptyTitle: { de: 'Noch kein Inventar', en: 'No inventory yet' },
  emptyMsg: {
    de: 'Dieser Standort hat noch keine Geräte gemeldet.',
    en: 'This site has not reported any devices yet.',
  },
} as const satisfies Namespace;
